import { useEffect, useRef } from "react";
import { motion, useInView, useMotionValue, useSpring } from "framer-motion";

// Animated count-up used in the social proof stats
export default function CountUp({ to, suffix = "", className = "" }) {
    const ref = useRef(null);
    const mv = useMotionValue(0);
    const spring = useSpring(mv, { stiffness: 55, damping: 20 });
    const inView = useInView(ref, { once: true, amount: 0.6 });

    useEffect(() => {
        if (inView) mv.set(to);
    }, [inView, to, mv]);

    useEffect(
        () =>
            spring.on("change", (v) => {
                if (ref.current)
                    ref.current.textContent = Math.round(v).toLocaleString(
                        "en-IN",
                    );
            }),
        [spring],
    );

    return (
        <span className={className}>
            <span ref={ref}>0</span>
            {suffix}
        </span>
    );
}
